module.exports = __webpack_public_path__ + "img/main.c55c8d42.jpg";